export const initialTdsFormValues = {
  tax_name: "",
  rate: 0,
  section_id: 0,
  is_percentage: true,
  tds_payable_account: 0,
  tds_receivable_account: 0,
  previous_tds_id: null,
};
